import { KeycloakConfig, UpdateStrategy } from "@ogs/ngx-keycloak";
import { HTTP_CONFIG } from "./http-configs/http.config";
import { CORE_ROUTES } from "@core/constants/routes.constant";
import { AUTHENTICATE_ROUTES } from "@features/authenticate/constants/routes.constant";
import { mergeHttpConfig } from "@ogs-gmbh/ngx-http";

export const KEYCLOAK_CONFIG: KeycloakConfig = {
  keycloak: {
    resource: "pls_client",
    realm: "bcl",
    storageKey: "auth-token",
    storageType: window.localStorage,
    useEmailAsCurrentUser: false,
    updateStrategy: UpdateStrategy.BOTH,
    guardFallbackUrl: `${ CORE_ROUTES.AUTHENTICATE }/${ AUTHENTICATE_ROUTES.LOGIN }`,
    reverseGuardFallbackUrl: CORE_ROUTES.PROJECTS
  },
  http: mergeHttpConfig(HTTP_CONFIG, {
    path: "/auth"
  })
};
